import {Fragment, useMemo} from 'react'

import {MemexActionType, MemexWorkflowTriggerType} from '../../api/workflows/contracts'
import {sortActionsByPriority} from '../../helpers/workflow-utilities'
import {useAutomationGraph} from '../../state-providers/workflows/use-automation-graph'
import styles from './automation-graph.module.css'
import {ActionBlock} from './blocks/action-block'
import {Connector} from './connector'

interface AutomationGraphProps {
  onNoSuggestedRepositories?: () => void
}

export const AutomationGraph = ({onNoSuggestedRepositories}: AutomationGraphProps) => {
  const {workflow} = useAutomationGraph()

  const sortedActions = useMemo(() => {
    const actions = workflow.actions.slice().sort(sortActionsByPriority)
    // Autopilot's GetProjectItems action is folded into AssignCopilotBlock and renders nothing
    // on its own. Drop it here so we don't emit a stray Connector between two visible blocks.
    if (workflow.triggerType === MemexWorkflowTriggerType.Autopilot) {
      return actions.filter(a => a.actionType !== MemexActionType.GetProjectItems)
    }
    return actions
  }, [workflow.actions, workflow.triggerType])

  return (
    <div className={styles.Box}>
      {sortedActions.map((action, index) => {
        return (
          <Fragment key={action.id ?? action.actionType}>
            <ActionBlock action={action} onNoSuggestedRepositories={onNoSuggestedRepositories} />
            {index < sortedActions.length - 1 && <Connector />}
          </Fragment>
        )
      })}
    </div>
  )
}
